
import { message } from 'antd'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { fetchWithToken } from '../../utils/fetch'
import { getHistory } from '../../utils/history'
import stepChecker from '../../utils/stepChecker'

class Contact {
  @observable loading: boolean = false
  @observable formData: object = {}

  constructor() {
    makeObservable(this)
  }

  @action
  async getAnswers() {
    try {
      this.loading = true
      const result = await fetchWithToken('registration/contact', {}, 'GET')
      if (result.status === 'success') {
        if (stepChecker(result.payload.step, 'contact')) {
          return getHistory().push(`/step/${result.payload.step}`)
        }
        runInAction(() => (this.formData = result.payload))
      } else if (result.status === 'completed') {
        getHistory().push('/step/submitted')
      }
    } catch (error) {
    console.error(error)
      message.error('มีข้อผิดพลาดเกิดขึ้น กรุณาลองอีกครั้ง')
    } finally {
      this.loading = false
    }
  }

  @action
  handleSave(data: object): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        this.loading = true
        const result = await fetchWithToken(
          'registration/contact/save',
          data,
          'PUT'
        )
        if (result.status === 'success') {
          if (resolve) {
            resolve()
          }
        }
      } catch (error) {
        if (reject) {
          reject()
        }
      } finally {
        this.loading = false
      }
    })
  }

  async handleSubmit(data: object) {
    try {
      this.loading = true
      const result = await fetchWithToken('registration/contact', data, 'PUT')
      if (result.status === 'success') {
        getHistory().push('/step/general')
      }
    } catch (error) {
    console.error(error)
      message.error('มีข้อผิดพลาดเกิดขึ้น กรุณาลองอีกครั้ง')
    } finally {
      this.loading = false
    }
  }
}

const contactInstance = new Contact()

export default contactInstance
